import _ from 'lodash';
window._ = _;

import './jquery-global.js';

// spectrum-colorpicker (unmaintained) still calls $.isArray, removed in jQuery 4.0
window.jQuery.isArray = window.jQuery.isArray || Array.isArray;

import 'jquery-ui/dist/jquery-ui.min';
import 'bootstrap';
import 'datatables.net-bs5';
import './app/amplitude';

import tinymce from 'tinymce/tinymce.min';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/models/dom';
import 'tinymce/plugins/link';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/skins/ui/oxide/skin.css';
window.tinymce = tinymce;

import 'spectrum-colorpicker';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
